import { Box, Text } from '@chakra-ui/react';
import React from 'react';

interface ProgressSliderProps {
  /** Current number of connected channels */
  connected: number;
  /** Total number of channels */
  total: number;
  /** Optional custom text to display below the slider */
  text?: string;
}

export const ProgressSlider: React.FC<ProgressSliderProps> = ({
  connected,
  total,
  text,
}) => {
  const progressPercentage = total > 0 ? (connected / total) * 100 : 0;
  const displayText = text || `${connected} of ${total} channels connected`;

  return (
    <Box>
      {/* Progress Bar */}
      <Box
        position="relative"
        w="full"
        h="12px"
        bg="gray.200"
        borderRadius="full"
        overflow="hidden">
        {/* Filled portion */}
        <Box
          position="absolute"
          left="0"
          top="0"
          h="100%"
          w={`${progressPercentage}%`}
          bg="icon.green"
          borderRadius="full"
          transition="width 0.3s ease-in-out"
        />
      </Box>

      {/* Text below */}
      <Text
        mt={2}
        fontSize="sm"
        color="gray.500"
        fontFamily="marketingPage"
        fontWeight="normal">
        {displayText}
      </Text>
    </Box>
  );
};
